import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class SizeGuide extends UcoastEl {
    static htmlSelector = 'size-guide'

    closeButton: HTMLButtonElement
    genderButtons: NodeListOf<HTMLButtonElement>
    sizeValues: NodeListOf<HTMLElement>
    sizeCells: NodeListOf<HTMLElement>
    sizeRows: NodeListOf<HTMLElement>
    openButtons: NodeListOf<HTMLButtonElement>

    constructor() {
        super()

        this.closeButton = q.rs('.size-guide__drawer-close', this)
        this.genderButtons = q.rl('.size-guide__drawer-gender', this)
        this.sizeValues = q.rl('span[data-gender]', this)
        this.sizeCells = q.rl('.size-guide__drawer-table--td', this)
        this.sizeRows = q.rl('.size-guide__drawer-table--row', this)
        this.openButtons = document.querySelectorAll('.size-guide__drawer-open')

        this.closeButton.addEventListener('click', this.close.bind(this))
        this.genderButtons.forEach(genderButton => {
            genderButton.addEventListener('click', this.onChangeValue.bind(this))
        })
        this.openButtons.forEach(openButton => {
            openButton.addEventListener('click', this.open.bind(this))
        })
        this.addEventListener('click', this.onClickBody.bind(this))
        this.sortRowsByCm()
        this.initializeVisibility()
    }

    sortRowsByCm() {
        const tableContent = q.rs('.size-guide__drawer-table--content', this)
        if(!tableContent) return

        const rows = Array.from(this.sizeRows)
        const headerRow = rows.shift()
        if(!headerRow) return

        rows.sort((a, b) => {
            const cmA = parseFloat(a.dataset.sortCm || '0')
            const cmB = parseFloat(b.dataset.sortCm || '0')
            return cmA - cmB
        })

        rows.forEach(row => tableContent.appendChild(row))
        if(headerRow) {
            tableContent.insertBefore(headerRow, tableContent.firstChild)
        }
    }

    initializeVisibility() {
        const activeGender = this.genderButtons[0]?.dataset.gender
        if(activeGender) {
            this.sizeValues.forEach(size => {
                size.classList.toggle('hidden', size.dataset.gender != activeGender)
            })
            this.sizeCells.forEach(cell => {
                const genderKey = `has${activeGender.charAt(0).toUpperCase() + activeGender.slice(1)}` as keyof DOMStringMap
                if (!(genderKey in cell.dataset)) return
                const hasContent = cell.dataset[genderKey] === 'true'
                cell.classList.toggle('hidden', !hasContent)
            })
            this.sizeRows.forEach(row => {
                if (!row.dataset.sortCm) return
                const genderKey = `has${activeGender.charAt(0).toUpperCase() + activeGender.slice(1)}` as keyof DOMStringMap
                const hasContent = row.dataset[genderKey] === 'true'
                row.classList.toggle('hidden', !hasContent)
            })
        }
    }

    open() {
        this.classList.add('active')
    }

    close() {
        this.classList.remove('active')
    }

    onChangeValue(e: Event) {
        const target = e.currentTarget as HTMLButtonElement
        if(!target) return
        const gender = target.dataset.gender
        if(!gender) return
        this.sizeValues.forEach(size => {
            size.classList.toggle('hidden', size.dataset.gender != gender)
        })
        this.sizeCells.forEach(cell => {
            const genderKey = `has${gender.charAt(0).toUpperCase() + gender.slice(1)}` as keyof DOMStringMap
            if (!(genderKey in cell.dataset)) return
            const hasContent = cell.dataset[genderKey] === 'true'
            cell.classList.toggle('hidden', !hasContent)
        })
        this.sizeRows.forEach(row => {
            if (!row.dataset.sortCm) return
            const genderKey = `has${gender.charAt(0).toUpperCase() + gender.slice(1)}` as keyof DOMStringMap
            const hasContent = row.dataset[genderKey] === 'true'
            row.classList.toggle('hidden', !hasContent)
        })
        this.genderButtons.forEach(genderButton => {
            genderButton.classList.remove('active')
        })
        target.classList.add('active')
    }

    onClickBody(e: Event) {
        const target = e.target as HTMLElement
        if(!target) return
        if(target.closest('.size-guide__drawer')) return
        this.close()
    }
}
